import { Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { createPlanPageSelectors, getSelectorAttribute } from '@vy/app-selectors';
import type { PlanInputFormUsageProduct } from '@vy/types';
import { withDefault } from '@vy/utils';
import { set } from 'lodash';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useMeters } from '../../../../../../../../hooks/requests/use-meters/use-meters';
import { getDefaultTiersUsageProduct } from '../../../../../create-plan-page-consts/add-item-button-consts';
import {
  PRO_RATA_SETTINGS,
  mapProRataSettingToProductFields,
} from '../../../../CreatePlanForm/create-plan-form-types/create-plan-form-sub-types';
import type { NewPlanForm } from '../../../../CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from '../../../../CreatePlanForm/create-plan-form-types/plan-input-form';

type UsageChargesMenuItemsProps = {
  selectedMetersIds?: string[];
};

export const UsageChargesMenuItems: React.FC<UsageChargesMenuItemsProps> = ({ selectedMetersIds }) => {
  const { setValue, getValues } = useFormContext<PlanInputForm, NewPlanForm>();
  const {
    data: { meters },
  } = useMeters();

  const filteredMeters = selectedMetersIds
    ? meters.filter(({ id }) => !selectedMetersIds?.includes(id))
    : meters;

  const handleProductClick = (defaultProductCallback: () => PlanInputFormUsageProduct, meterId?: string) => {
    return () => {
      const currentProducts = withDefault(getValues('usageProducts'), []);
      const defaultProduct = defaultProductCallback();
      const proRataSetting = getValues('proRataSetting') ?? PRO_RATA_SETTINGS.PRO_RATA_AND_CALENDAR_ALIGNED;
      const { proRata, isCalendarAligned } = mapProRataSettingToProductFields(proRataSetting);
      const productWithProRataSettings = { ...defaultProduct, proRata, isCalendarAligned };
      const defaultProductWithPreviousMeterId = set(productWithProRataSettings, 'variants[0].meterId', meterId);
      const updatedProducts = [...currentProducts, defaultProductWithPreviousMeterId];
      setValue('usageProducts', updatedProducts);
    };
  };

  return (
    <>
      {filteredMeters.map(({ id, name }) => (
        <MenuItem
          key={id}
          className="flex flex-col items-start"
          onClick={handleProductClick(getDefaultTiersUsageProduct, id)}
          {...getSelectorAttribute(createPlanPageSelectors.tabs.sections.usageCharges.meterMenuItem)}
        >
          <Typography className="text-sm font-normal text-black">{name}</Typography>
        </MenuItem>
      ))}
    </>
  );
};
